import React from 'react';
import { Marker } from 'react-map-gl';
import { MapVesselData } from './OverviewMap';

interface PinPropTypes {
  size?: number;
  data?: MapVesselData[];
  onClick?: (vessel: any) => any;
}

const ICON = `M10.368,19.102c0.349,1.049,1.011,1.086,1.478,0.086l5.309-11.375c0.467-1.002,0.034-1.434-0.967-0.967L4.812,12.154   c-1.001,0.467-0.963,1.129,0.085,1.479L9,15L10.368,19.102z`;

const Pin: React.FC<PinPropTypes> = ({ size=30, data, onClick }) => {
  return (
    <>
      {
        data?.map((vessel: MapVesselData, index: number) => (
          <Marker
            key={`marker-${index}`}
            longitude={vessel.longitude}
            latitude={vessel.latitude}
          >
            <svg
              height={size}
              viewBox="0 0 24 24"
              style={{
                fill: vessel.color,
                stroke: 'grey'
              }}
              onClick={onClick ? () => onClick(vessel) : undefined}
              role={onClick ? 'button' : undefined}
              tabIndex={onClick ? 0 : undefined}
              aria-label={onClick ? `Ship: ${vessel.name}` : undefined}
              onKeyDown={onClick ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClick(vessel);
                }
              } : undefined}
            >
              <path d={ICON} />
            </svg>
          </Marker>
        ))
      }
    </>
  )
};

export default Pin;